import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { IdValidationService } from '@services/index';
@Injectable({
  providedIn: 'root',
})
export class CustomValidatorService {
  constructor(private idValidationService: IdValidationService) {}

  public ValidIdNumber(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (!value) {
        return null;
      }

      const valid = this.idValidationService.isValid(value);

      return !valid ? { idNotValid: true } : null;
    };
  }
}
